(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lfe-app-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.getElementById('lfe-app-banner');
    if (!banner || banner.dataset.initialized) return;
    banner.dataset.initialized = 'true';

    const ua = navigator.userAgent || '';
    const ios = /iPhone|iPod/i.test(ua);
    const android = /Android/i.test(ua);
    const inApp = /Shopney|LFEApp|; wv\)/i.test(ua) ||
      (ios && !/Safari|CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua));
    if ((!ios && !android) || inApp || navigator.standalone ||
        window.matchMedia('(display-mode: standalone)').matches) return;

    const storageKey = 'lfe-app-banner-dismissed-until-v1';
    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    const stores = [];
    try { stores.push(window.localStorage); } catch (_) {}
    try { stores.push(window.sessionStorage); } catch (_) {}
    const isDismissed = () => stores.some((storage) => {
      try { return Number(storage.getItem(storageKey)) > Date.now(); }
      catch (_) { return false; }
    });
    if (isDismissed()) return;

    const download = banner.querySelector('.lfe-app-banner__download');
    const close = banner.querySelector('.lfe-app-banner__close');
    const store = banner.querySelector('.lfe-app-banner__store');
    download.href = ios ? banner.dataset.iosUrl : banner.dataset.androidUrl;
    download.setAttribute('aria-label', ios ? banner.dataset.iosLabel : banner.dataset.androidLabel);
    store.textContent = ios ? banner.dataset.iosStore : banner.dataset.androidStore;

    const dismiss = () => {
      const until = String(Date.now() + sevenDays);
      stores.forEach((storage) => {
        try { storage.setItem(storageKey, until); } catch (_) {}
      });
      banner.hidden = true;
    };
    close.addEventListener('click', dismiss);
    window.addEventListener('storage', (event) => {
      if (event.key === storageKey && isDismissed()) banner.hidden = true;
    });
    window.addEventListener('pageshow', () => {
      if (isDismissed()) banner.hidden = true;
    });
    banner.hidden = false;
  })();
  } catch(e) { console.error(e); }
})();

})();
